import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import WhatsAppIcon from './icons/WhatsAppIcon';
import { useCMS } from '../store/cmsStore';

export default function WhatsAppButton() {
  const { data } = useCMS();
  const [isOpen, setIsOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowTooltip(true), 3000);
    const hideTimer = setTimeout(() => setShowTooltip(false), 8000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  const quickMessages = [
    'أريد الاستفسار عن باقة العمرة الاقتصادية',
    'أريد الاستفسار عن باقة VIP',
    'أريد حجز مقعد في الباص',
    'ما هي الأسعار المتاحة؟',
  ];

  return (
    <div className="fixed bottom-4 left-4 md:bottom-6 md:left-6 z-50">
      {/* Quick Messages Panel */}
      {isOpen && (
        <div className="mb-4 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden w-[calc(100vw-2rem)] max-w-80">
          {/* Header */}
          <div className="bg-brown-600 p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <img src="/logo.jpeg" alt={`${data.settings.siteName} للخدمات السياحية والعمرة`} className="w-10 h-10 rounded-full object-cover" width="40" height="40" />
                <div>
                  <h4 className="text-white font-cairo font-bold text-sm">{data.settings.siteName}</h4>
                  <p className="text-brown-200 text-xs font-cairo">متصل الآن</p>
                </div>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-white/70 hover:text-white">
                <X size={20} />
              </button>
            </div>
          </div>

          {/* Messages */}
          <div className="p-4 space-y-3">
            <div className="bg-brown-50 rounded-xl p-3 border border-brown-100">
              <p className="text-brown-800 font-cairo text-sm">
                السلام عليكم! 👋 كيف يمكننا مساعدتك اليوم؟
              </p>
            </div>

            {quickMessages.map((message, index) => (
              <a
                key={index}
                href={`https://wa.me/${data.settings.whatsapp}?text=${encodeURIComponent(message)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-gray-50 hover:bg-brown-50 rounded-xl p-3 border border-gray-100 hover:border-brown-200 transition-all text-right"
              >
                <p className="text-gray-700 font-cairo text-sm hover:text-brown-700">{message}</p>
              </a>
            ))}
          </div>

          {/* Input */}
          <div className="p-4 border-t border-gray-100">
            <a
              href={`https://wa.me/${data.settings.whatsapp}?text=السلام عليكم، أريد الاستفسار عن خدمات العمرة`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-brown-600 hover:bg-brown-700 py-3 rounded-xl text-white font-cairo font-bold text-center flex items-center justify-center gap-2 transition-all"
            >
<WhatsAppIcon className="w-5 h-5" />
              فتح واتساب
            </a>
          </div>
        </div>
      )}

      {/* Tooltip */}
      {showTooltip && !isOpen && (
        <div className="mb-4 bg-white rounded-xl shadow-lg p-3 max-w-48">
          <p className="text-gray-700 font-cairo text-sm">مرحباً! كيف يمكننا مساعدتك؟</p>
        </div>
      )}

      {/* Main Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-green-500 hover:bg-green-600 text-white w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110"
      >
        {isOpen ? (
          <X size={24} />
        ) : (
          <svg className="w-7 h-7 md:w-8 md:h-8" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
        )}
      </button>
    </div>
  );
}